<template>
    <div class="paySuccess main center">
        <Icon type="md-checkmark-circle-outline" size="60" color="green"/>
        <!-- <h2 class="paySuccess-title"></h2> -->
        <p class="paySuccess-subtitle">投保信息提交成功，请耐心等待核保。</p>
        <Button type="primary" @click="detail">查看详情</Button>
    </div>
</template>
<script>
export default {
    data(){
        return {
            id:this.$route.params.id||''
        }
    },
    methods: {
        detail() {
            location.href=`/haierProduct.html#/my/customizedTPL/insuranceDetail/${this.id}`
        }
    },
}
</script>
<style scoped lang="less">
.paySuccess{
    padding:50px 20px;
    &-title{
        margin-top: 20px;
    }
    &-subtitle{
        color: red;
        font-size: 14px;
        margin-top: 10px;
        margin-bottom: 30px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/forklift/success.vue